<template>
  <div class="main-container" @click="$emit('click')">
    <div
      class="height-strut"
      ref="height-strut"
      :style="heightStrutStyle"
    ></div>
    <div
      class="first-content-wrapper"
      ref="first-content-wrapper"
      :style="firstStyle"
    >
      <slot name="first"></slot>
    </div>
    <div
      class="second-content-wrapper"
      ref="second-content-wrapper"
      :style="secondStyle"
    >
      <slot name="second"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeightSwitcher',
  props: {
    unlocked: { type: Boolean, default: false },
    skipFirstFade: { type: Boolean, default: false },
  },
  data() {
    return {
      firstStyle: {},
      secondStyle: {
        opacity: 0,
        position: 'absolute',
        visibility: 'hidden',
      },
      heightStrutStyle: { height: 'auto', display: 'none' },
    }
  },
  mounted() {
    if (this.unlocked) {
      this.firstStyle = {
        opacity: 0,
        position: 'absolute',
        visibility: 'hidden',
      }
      this.secondStyle = {}
    }
  },
  methods: {
    fadeOut(ref) {
      return new Promise((resolve) => {
        this.$refs[ref].addEventListener(
          'transitionend',
          function transitionEnd() {
            this.$refs[ref].removeEventListener('transitionend', transitionEnd)
            //this.transitionHeightOneToTwo()
            resolve()
            /*this.transitionHeight(
            'first-content-wrapper',
            'second-content-wrapper'
          )*/
          }.bind(this)
        )
        if (ref == 'first-content-wrapper') {
          this.firstStyle = { opacity: 0 }
        } else if (ref == 'second-content-wrapper') {
          this.secondStyle = { opacity: 0 }
        }
      })
    },
    /*fadeOutOne() {
      return new Promise((resolve) => {
        this.$refs['first-content-wrapper'].addEventListener(
          'transitionend',
          function transitionEnd() {
            this.$refs['first-content-wrapper'].removeEventListener(
              'transitionend',
              transitionEnd
            )
            //this.transitionHeightOneToTwo()
            resolve()
            this.transitionHeight(
            'first-content-wrapper',
            'second-content-wrapper'
          )
          }.bind(this)
        )
        this.firstStyle = { opacity: 0 }
      })
    },
    fadeOutTwo() {
      this.$refs['second-content-wrapper'].addEventListener(
        'transitionend',
        function transitionEnd() {
          this.$refs['second-content-wrapper'].removeEventListener(
            'transitionend',
            transitionEnd
          )
          //this.transitionHeightTwoToOne()
          this.transitionHeight(
            'second-content-wrapper',
            'first-content-wrapper'
          )
        }.bind(this)
      )
      this.secondStyle = { opacity: 0 }
    },*/
    /*transitionHeightOneToTwo() {
      const firstHeight = this.$refs[
        'first-content-wrapper'
      ].getBoundingClientRect().height
      this.heightStrutStyle = { height: firstHeight + 'px' }
      console.log('set heightStrutStyle to', this.heightStrutStyle)
      this.firstStyle = { display: 'none' }

      this.$nextTick(() => {
        const secondHeight = this.$refs[
          'second-content-wrapper'
        ].getBoundingClientRect().height
        this.heightStrutStyle = { height: secondHeight + 'px' }
        console.log('set heightStrutStyle to', this.heightStrutStyle)

        this.$refs['height-strut'].addEventListener(
          'transitionend',
          function transitionEnd() {
            this.$refs['height-strut'].removeEventListener(
              'transitionend',
              transitionEnd
            )
            this.fadeInTwo()
          }.bind(this)
        )
      })
    },*/
    transitionHeight(first, second) {
      return new Promise((resolve) => {
        const firstHeight = this.$refs[first].getBoundingClientRect().height
        this.heightStrutStyle = { height: firstHeight + 'px' }
        console.log('set heightStrutStyle to', this.heightStrutStyle)

        if (first == 'first-content-wrapper') {
          this.firstStyle = { display: 'none' }
        } else if (first == 'second-content-wrapper') {
          this.secondStyle = { display: 'none' }
        }

        this.$nextTick(() => {
          const secondHeight = this.$refs[second].getBoundingClientRect().height
          this.heightStrutStyle = { height: secondHeight + 'px' }
          console.log('set heightStrutStyle to', this.heightStrutStyle)

          this.$refs['height-strut'].addEventListener(
            'transitionend',
            function transitionEnd() {
              this.$refs['height-strut'].removeEventListener(
                'transitionend',
                transitionEnd
              )
              //this.fadeInTwo()
              resolve()
            }.bind(this)
          )
        })
      })
    },
    /*
    transitionHeightTwoToOne() {
      const firstHeight = this.$refs[
        'second-content-wrapper'
      ].getBoundingClientRect().height
      this.heightStrutStyle = { height: firstHeight + 'px' }
      console.log('set heightStrutStyle to', this.heightStrutStyle)
      this.secondStyle = { display: 'none' }

      this.$nextTick(() => {
        const secondHeight = this.$refs[
          'first-content-wrapper'
        ].getBoundingClientRect().height
        this.heightStrutStyle = { height: secondHeight + 'px' }
        console.log('set heightStrutStyle to', this.heightStrutStyle)

        this.$refs['height-strut'].addEventListener(
          'transitionend',
          function transitionEnd() {
            this.$refs['height-strut'].removeEventListener(
              'transitionend',
              transitionEnd
            )
            this.fadeInOne()
          }.bind(this)
        )
      })
    },
    },*/
    fadeIn(ref) {
      return new Promise((resolve) => {
        if (ref == 'first-content-wrapper') {
          this.firstStyle = { opacity: 1 }
        } else if (ref == 'second-content-wrapper') {
          this.secondStyle = { opacity: 1 }
        }
        this.heightStrutStyle = { height: 'auto', display: 'none' }
        this.$refs[ref].addEventListener(
          'transitionend',
          function transitionEnd() {
            this.$refs[ref].removeEventListener('transitionend', transitionEnd)
            this.$emit('switched')
            resolve()
          }.bind(this)
        )
      })
    },
    /*fadeInOne() {
      this.firstStyle = { opacity: 1 }
      this.heightStrutStyle = { height: 'auto', display: 'none' }
      this.$refs['first-content-wrapper'].addEventListener(
        'transitionend',
        function transitionEnd() {
          this.$refs['first-content-wrapper'].removeEventListener(
            'transitionend',
            transitionEnd
          )
          this.$emit('switched')
        }.bind(this)
      )
    },
    fadeInTwo() {
      this.secondStyle = { opacity: 1 }
      this.heightStrutStyle = { height: 'auto', display: 'none' }
      this.$refs['second-content-wrapper'].addEventListener(
        'transitionend',
        function transitionEnd() {
          this.$refs['second-content-wrapper'].removeEventListener(
            'transitionend',
            transitionEnd
          )
          this.$emit('switched')
        }.bind(this)
      )
    },*/
  },
  watch: {
    unlocked(new_val, old_val) {
      console.log('unlocked watcher: ', new_val, old_val)
      let first, second
      if (new_val && !old_val) {
        first = 'first-content-wrapper'
        second = 'second-content-wrapper'
      } else {
        first = 'second-content-wrapper'
        second = 'first-content-wrapper'
      }
      if (!this.skipFirstFade) {
        this.fadeOut(first)
          .then(() => {
            return this.transitionHeight(first, second)
          })
          .then(() => {
            this.fadeIn(second)
          })
      } else {
        this.transitionHeight(first, second).then(() => {
          this.fadeIn(second)
        })
      }
    },
  },
}
</script>

<style scoped>
.height-strut {
  transition: height 0.3333s;
  /*outline: solid 3px green;*/
}

.main-container {
  position: relative;
  width: 100%;
  /*outline: solid 1px red;
  background-color: white;*/
}

/*
add negligible padding top prevent collapsing margins and allow correct height
of element to be determined from the boundingClientRect
*/
.first-content-wrapper {
  width: 100%;
  transition: opacity 0.3333s;
  padding: 0.05px;
}

.second-content-wrapper {
  width: 100%;
  transition: opacity 0.3333s;
  padding: 0.05px;
}
</style>
